import { useEffect } from 'react';

/**
 * Sets document.title and meta description for a page.
 * Called at the top of each page component.
 */
export function useSEO(title: string, description: string) {
  useEffect(() => {
    document.title = title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', description);
    }
  }, [title, description]);
}
